 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"canvg":"canvg","default~core-dashboard-dashboard-module~core-pages-pages-module":"default~core-dashboard-dashboard-module~core-pages-pages-module","core-dashboard-dashboard-module":"core-dashboard-dashboard-module","default~core-pages-pages-module~hospitality-bot-admin-all-outlets~libs-admin-agent-src-lib-admin-age~5b856b26":"default~core-pages-pages-module~hospitality-bot-admin-all-outlets~libs-admin-agent-src-lib-admin-age~5b856b26","default~core-pages-pages-module~hospitality-bot-admin-tax~libs-admin-global-shared-src-lib-admin-glo~2f90cc75":"default~core-pages-pages-module~hospitality-bot-admin-tax~libs-admin-global-shared-src-lib-admin-glo~2f90cc75","default~core-pages-pages-module~libs-admin-guests-src-lib-admin-guests-module~libs-admin-request-src~16b6f3b9":"default~core-pages-pages-module~libs-admin-guests-src-lib-admin-guests-module~libs-admin-request-src~16b6f3b9","default~core-pages-pages-module~libs-admin-guests-src-lib-admin-guests-module":"default~core-pages-pages-module~libs-admin-guests-src-lib-admin-guests-module","default~core-pages-pages-module~hospitality-bot-admin-manage-sites":"default~core-pages-pages-module~hospitality-bot-admin-manage-sites","default~core-pages-pages-module~hospitality-bot-admin-all-outlets":"default~core-pages-pages-module~hospitality-bot-admin-all-outlets","core-pages-pages-module":"core-pages-pages-module","dompurify":"dompurify","file-saver":"file-saver","firebase-messaging":"firebase-messaging","hospitality-bot-admin-unsubscribed":"hospitality-bot-admin-unsubscribed","html2canvas":"html2canvas","default~hospitality-bot-admin-agent~hospitality-bot-admin-guests~hospitality-bot-admin-manage-reserv~6d2de568":"default~hospitality-bot-admin-agent~hospitality-bot-admin-guests~hospitality-bot-admin-manage-reserv~6d2de568","default~hospitality-bot-admin-guests~libs-admin-guests-src-lib-admin-guests-module":"default~hospitality-bot-admin-guests~libs-admin-guests-src-lib-admin-guests-module","default~hospitality-bot-admin-company~libs-admin-company-src-lib-admin-company-module":"default~hospitality-bot-admin-company~libs-admin-company-src-lib-admin-company-module","default~hospitality-bot-admin-request-analytics~hospitality-bot-admin-roles-and-permissions~hospital~21096ba7":"default~hospitality-bot-admin-request-analytics~hospitality-bot-admin-roles-and-permissions~hospital~21096ba7","default~hospitality-bot-admin-service-item~libs-admin-service-item-src-lib-admin-service-item-module":"default~hospitality-bot-admin-service-item~libs-admin-service-item-src-lib-admin-service-item-module","libs-admin-service-item-src-lib-admin-service-item-module":"libs-admin-service-item-src-lib-admin-service-item-module","default~hospitality-bot-admin-packages~hospitality-bot-admin-settings~libs-admin-settings-src-lib-ad~e8167464":"default~hospitality-bot-admin-packages~hospitality-bot-admin-settings~libs-admin-settings-src-lib-ad~e8167464","default~hospitality-bot-admin-request~hospitality-bot-admin-request-analytics~libs-admin-request-src~e9d963eb":"default~hospitality-bot-admin-request~hospitality-bot-admin-request-analytics~libs-admin-request-src~e9d963eb","default~hospitality-bot-admin-invoice~libs-admin-invoice-src-lib-admin-invoice-module~libs-admin-inv~4a118cbb":"default~hospitality-bot-admin-invoice~libs-admin-invoice-src-lib-admin-invoice-module~libs-admin-inv~4a118cbb","default~hospitality-bot-admin-invoice~libs-admin-invoice-src-lib-admin-invoice-module":"default~hospitality-bot-admin-invoice~libs-admin-invoice-src-lib-admin-invoice-module","common":"common","hospitality-bot-admin-roles-and-permissions":"hospitality-bot-admin-roles-and-permissions","product-product-module":"product-product-module","hospitality-bot-admin-tax":"hospitality-bot-admin-tax","hospitality-bot-admin-business":"hospitality-bot-admin-business","hospitality-bot-admin-subscription":"hospitality-bot-admin-subscription","hospitality-bot-admin-assets":"hospitality-bot-admin-assets","hospitality-bot-admin-campaign":"hospitality-bot-admin-campaign","hospitality-bot-admin-dynamic-pricing":"hospitality-bot-admin-dynamic-pricing","hospitality-bot-admin-listing":"hospitality-bot-admin-listing","hospitality-bot-admin-room":"hospitality-bot-admin-room","hospitality-bot-admin-setup-bar-price":"hospitality-bot-admin-setup-bar-price","hospitality-bot-admin-manage-reservation":"hospitality-bot-admin-manage-reservation","hospitality-bot-admin-guests":"hospitality-bot-admin-guests","hospitality-bot-admin-company":"hospitality-bot-admin-company","default~hospitality-bot-admin-conversation-analytics~hospitality-bot-admin-dashboard~hospitality-bot~b0f3ce95":"default~hospitality-bot-admin-conversation-analytics~hospitality-bot-admin-dashboard~hospitality-bot~b0f3ce95","hospitality-bot-admin-dashboard":"hospitality-bot-admin-dashboard","default~hospitality-bot-admin-conversation-analytics~hospitality-bot-admin-messages":"default~hospitality-bot-admin-conversation-analytics~hospitality-bot-admin-messages","hospitality-bot-admin-conversation-analytics":"hospitality-bot-admin-conversation-analytics","default~hospitality-bot-admin-feedback~hospitality-bot-admin-services":"default~hospitality-bot-admin-feedback~hospitality-bot-admin-services","hospitality-bot-admin-services":"hospitality-bot-admin-services","hospitality-bot-admin-request-analytics":"hospitality-bot-admin-request-analytics","hospitality-bot-admin-feedback-analytics":"hospitality-bot-admin-feedback-analytics","hospitality-bot-admin-marketing-dashboard":"hospitality-bot-admin-marketing-dashboard","hospitality-bot-admin-messages":"hospitality-bot-admin-messages","default~hospitality-bot-admin-housekeeping~hospitality-bot-admin-manage-inventory~hospitality-bot-ad~eebf0205":"default~hospitality-bot-admin-housekeeping~hospitality-bot-admin-manage-inventory~hospitality-bot-ad~eebf0205","default~hospitality-bot-admin-housekeeping~hospitality-bot-admin-reports":"default~hospitality-bot-admin-housekeeping~hospitality-bot-admin-reports","hospitality-bot-admin-housekeeping":"hospitality-bot-admin-housekeeping","hospitality-bot-admin-reports":"hospitality-bot-admin-reports","default~hospitality-bot-admin-manage-inventory~hospitality-bot-admin-manage-rate~hospitality-bot-adm~ab5c7a69":"default~hospitality-bot-admin-manage-inventory~hospitality-bot-admin-manage-rate~hospitality-bot-adm~ab5c7a69","hospitality-bot-admin-manage-inventory":"hospitality-bot-admin-manage-inventory","hospitality-bot-admin-manage-rate":"hospitality-bot-admin-manage-rate","hospitality-bot-admin-invoice":"hospitality-bot-admin-invoice","hospitality-bot-admin-update-rates-and-inventory":"hospitality-bot-admin-update-rates-and-inventory","hospitality-bot-admin-packages":"hospitality-bot-admin-packages","hospitality-bot-admin-service-item":"hospitality-bot-admin-service-item","hospitality-bot-admin-request":"hospitality-bot-admin-request","hospitality-bot-admin-channel-manager-restrictions":"hospitality-bot-admin-channel-manager-restrictions","hospitality-bot-admin-create-with":"hospitality-bot-admin-create-with","hospitality-bot-admin-finance":"hospitality-bot-admin-finance","hospitality-bot-admin-kot":"hospitality-bot-admin-kot","hospitality-bot-admin-menu":"hospitality-bot-admin-menu","hospitality-bot-admin-offers":"hospitality-bot-admin-offers","hospitality-bot-admin-outlets-dashboard":"hospitality-bot-admin-outlets-dashboard","hospitality-bot-admin-petty-cash":"hospitality-bot-admin-petty-cash","hospitality-bot-admin-quick-replies":"hospitality-bot-admin-quick-replies","hospitality-bot-admin-sentimental-analysis":"hospitality-bot-admin-sentimental-analysis","hospitality-bot-admin-template":"hospitality-bot-admin-template","hospitality-bot-admin-topic":"hospitality-bot-admin-topic","hospitality-bot-admin-view-not-allowed":"hospitality-bot-admin-view-not-allowed","hospitality-bot-table-management":"hospitality-bot-table-management","hospitality-bot-admin-all-outlets":"hospitality-bot-admin-all-outlets"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
